export enum OutboundShipmentState {
  Draft = "draft",
  Ready = "ready",
  Sent = "sent",
}
